<script>
	import { getNewIcon } from "../../card_images";
	import "../shared.css";
	import { parseRestriction } from "./helpers";

	export let restriction;
	export let textColor;
	let parsed;

	$: parsed = parseRestriction(restriction);

	const getRestrictionIcon = (spec) => {
		switch (spec) {
			case 'res':
				return getNewIcon('res-restriction');
			case 'inf':
				return getNewIcon('inf-restriction');
			case 'mil':
				return getNewIcon('mil-restriction');
		}
	};
</script>

<span class="op-req">
	<span class="font-body" style="color:{textColor}"><i>Requires</i></span>
	{#if parsed?.type === 'specialty'}
		<div class="op-req-bg" style="--baseWidth:3.2em;--variableWidth:0px">
			<img class="restriction" src={getNewIcon(parsed.specialty)} />
			<div class="value font-block">{parsed.threshold}</div>
		</div>
	{:else if parsed?.type === 'captain'}
		<!--<div
			class="op-req-bg"
			style="--baseWidth:3.5em;--variableWidth:{getTraitLabelWidth(
				parsed.trait,
				'100 14px Antonio'
			)}px"
		>-->
		<div class="op-req-bg" style="--baseWidth: 2.9em; --variableWidth: 0px">
			<img class="restriction" src={getNewIcon('cap-restriction')} />
			<!--<div class="trait">
				<TraitChip restriction trait={parsed.trait} />
			</div>-->
			<img class="res_value" src={getNewIcon(parsed.icon)} />
		</div>
	{:else if parsed?.type === 'suit'}
		<div
			class="op-req-bg"
			style="--baseWidth:3.15em;--variableWidth:{getTraitLabelWidth(
				parsed.suit,
				'100 13px Antonio'
			)}px"
		>
			<div class="suit">
				<SuitChip restriction suit={parsed.suit} />
			</div>
			<div class="value font-block">{parsed.threshold}</div>
		</div>
	{/if}
</span>

<style lang="scss">
	.op-req span {
		font-size: calc(var(--height) / 28.643); //14px;
	}
	.op-req-bg {
		height: 0.8em;
		width: calc(var(--baseWidth) + var(--variableWidth));
		margin: 0 calc(var(--height) / 200.5); //0 2px;
		background-color: #222;
		display: inline-block;
		position: relative;
		& div {
			position: absolute;
		}
		& img.restriction {
			position: absolute;
			left: calc(var(--height) / 200.5);
			top: -45%;
			height: 1.25em;
		}
		& img.res_value {
			position: absolute;
			right: calc(var(--height) / 133.67);
			top: -45%;
			height: 1.25em;
			color: white;
			filter: brightness(0) invert(1) ;
		}
	}
	@mixin stroke($color: #000, $size: 1px) {
		text-shadow:
			-#{$size} -#{$size} 0 $color,
			0 -#{$size} 0 $color,
			#{$size} -#{$size} 0 $color,
			#{$size} 0 0 $color,
			#{$size} #{$size} 0 $color,
			0 #{$size} 0 $color,
			-#{$size} #{$size} 0 $color,
			-#{$size} 0 0 $color;
	}
	.value {
		color: white;
		font-size: 1em;
		right: calc(var(--height) / 133.67);
		top: 35%;
		transform: translate(0, -45%);
		@include stroke(#222, 2px);
	}
</style>
